import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import cookieUtils from "../utils/Cookies";
import { getItem, setItem, removeItem } from "../utils/localStorageControl";
import { clearcart } from "../services/cartservice";
import { AUTH_COOKIE_NAME } from "@/utils/constants";

// ---------------------------------------------------------------------------
// Encrypted persistence plugin
// ---------------------------------------------------------------------------
// vuex-persistedstate's storage hooks call getItem/setItem/removeItem.
// By wiring them to our encrypted localStorageControl helpers, every field
// that is persisted to localStorage is AES-encrypted at rest automatically.
const encryptedStorage = {
  getItem: (key) => getItem(key),
  setItem: (key, value) => setItem(key, value),
  removeItem: (key) => removeItem(key),
};

export default createStore({
  plugins: [
    createPersistedState({
      storage: encryptedStorage,
    }),
  ],
  state: {
    loggedUser: {},
    cartItems: [],
    refresh_token: "",
    access_token: "",
    isLoggedIn: false,
    roles: [],
    userId: "",
  },
  getters: {
    isLoggedIn: () => cookieUtils.get("token"),
    loggedUser: () => cookieUtils.get(AUTH_COOKIE_NAME),
    // eslint-disable-next-line no-unused-vars
    userApps: () => cookieUtils.get(AUTH_COOKIE_NAME)?.subAppCodes,
    userId: (state) => state.userId,
    token: (state) => (state.loggedUser ? state.loggedUser.jwToken : null),
    userType: () => cookieUtils.get("roles")?.[0],
    cartItems: (state) => state.cartItems,
    accessToken: () => cookieUtils.get("token"),
    refreshToken: () => cookieUtils.get(AUTH_COOKIE_NAME)?.refresh_token,
    cartTotal: (state) => state.cartItems.length,
    totalAmount: (state) => {
      return state.cartItems
        .map((item) => item.packagePrice * item.quantity)
        .reduce((a, b) => {
          return Number(a) + Number(b);
        }, 0);
    },
  },
  mutations: {
    setUser(state, data) {
      state.loggedUser = data;
      state.roles = data.roles;
      state.isLoggedIn = true;
      state.userId = data.id;
      state.refresh_token = data.refreshToken;
      state.access_token = data.jwToken;
    },
    setUserId(state, id) {
      state.userId = id;
    },
    setRefreshToken(state, refreshToken) {
      state.refresh_token = refreshToken;
    },
    setAccessToken(state, token) {
      state.access_token = token;
    },

    clearUserData(state) {
      state.loggedUser = {};
      state.refresh_token = "";
      state.access_token = "";
      state.isLoggedIn = false;
      state.userId = "";
    },
    clearCart(state) {
      state.cartItems = [];
    },
    addToCart(state, item) {
      state.cartItems = [...state.cartItems, item];
    },
    updateCart(state, item) {
      state.cartItems = [...item];
    },
    setCart(state, item) {
      state.cartItems = item;
    },
    removeFromCart(state, packageId) {
      state.cartItems = state.cartItems.filter(
        (item) => item.packageId !== packageId
      );
    },
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    async handleAddToCart({ state, commit }, item) {
      let check = state.cartItems.some((i) => i.packageId == item.packageId);
      if (check) {
        return { status: false, message: "Already in cart" };
      }
      commit("addToCart", item);
      return { status: true, message: "Added to cart" };
    },
    async handleCartUpdate({ state, commit }, item) {
      let updatedItem = state.cartItems.map((i) => {
        if (i.packageId == item.packageId) {
          i.quantity = item.quantity;
        }
        return i;
      });

      commit("updateCart", updatedItem);
    },
    async handleClearCart({ commit, state }, buyerId) {
      console.log(buyerId);

      const config = {
        headers: { Authorization: `Bearer ${state.loggedUser.jwToken}` },
      };
      await clearcart({ buyerId }, config);
      commit("clearCart");
    },
    async handleToken({ commit }, token) {
      commit("setAccessToken", token);
      return { status: true, message: "updated" };
    },
  },
  modules: {},
});
